import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              Inception Dev
            </Link>
          </div>
          <small class='website-rights'>Inception Dev © 2021</small>
          <div class='social-icons'>
            <Link
              class='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i class='fab fa-youtube' />
            </Link>
            <Link
              class='social-icon-link discord'
              to='/'
              target='_blank'
              aria-label='Discord'
            >
              <i class='fab fa-discord' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to=''
              target='_blank'
              aria-label='twitter'
            >
              <i class='fab fa-twitter' />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
